import { render } from "./MessageIndicator.vue?vue&type=template&id=6f89a99c&scoped=true&ts=true"
import script from "./MessageIndicator.vue?vue&type=script&lang=ts"
export * from "./MessageIndicator.vue?vue&type=script&lang=ts"

import "./MessageIndicator.vue?vue&type=style&index=0&id=6f89a99c&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f89a99c"]])

export default __exports__